const lbaToast = angular.module('app.lbaToast', []);

lbaToast.controller('lbaToastCtrl', require('./lbaToastCtrl'));
lbaToast.directive('lbaToast', require('./lbaToastDir'));

export default lbaToast;



// WEBPACK FOOTER //
// ./src/components/lbaToast/index.js